<template>
	<div class="editCardBlock">
		<vx-card class="editTicket card-ticket">
		<ConfirmMarginalityAction
		  :active.sync="marginalityPopupState"
		  class="marginality-popup"
		  @confirm="createTask"
		  @cancel="marginalityPopupState = false"
		/>
			<CardTicketIntercom
				ref="CardTicketIntercom"
				:model="model"
				@updateModel="$emit('updateModel')"
			/>
			<vs-tabs
			  :value="indexTab"
			  class="edit-ticket-tabs"
			  @setActiveTab="setActiveTab" @setButtonAction="setButtonAction"
			>
				<vs-tab :label="$t('informationAboutOrder')">
					<div>
						<div v-if="model.parent_id" class="vx-row mt-5">
							<div class="vx-col pt-2 sm:w-1/3 font-bold">{{ $t('mainOrder') }}</div>
							<div class="vx-col pt-2 sm:w-1/3">
								<router-link :to="'/ticket/' + model.parent_id" target="_blank">
									{{ model.parent_id }}
								</router-link>
							</div>
						</div>
						<div class="vx-row mt-1">
							<div class="vx-col pt-2 sm:w-1/3 font-bold">{{ $t('site') }}</div>
							<div class="vx-col pt-2 sm:w-1/3">
								{{ websiteName }}
							</div>
						</div>
						<div class="vx-row mt-1">
							<div class="vx-col pb-2 sm:w-1/3 font-bold">{{ $t('date') }}</div>
							<div class="vx-col pb-2 sm:w-1/3">
								{{ model.created }}
							</div>
						</div>
						<div class="vx-row">
							<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('client') }}</div>
							<div class="vx-col pt-2 pb-2 sm:w-1/3">
								<RouterLink :to="`/${pathToClient}/${clientId}`">
									{{ clientName }}
								</RouterLink>
							</div>
						</div>
						<div class="vx-row">
							<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('contactTime') }}</div>
							<div class="vx-col sm:w-1/3 w-full">
								<div class="flex items-center space-x-2">
									<div class="vs-component vs-con-input-label vs-input vs-input-primary w-full">
										<vs-datepicker
											v-model="model.contact_time"
											:clearable="false"
											@change="updateTicket(true)"
											format="dd.MM.yyyy"
											name="date"
										/>
									</div>

									<vs-button
										icon
										color="danger"
										type="border"
										class="delete-contact-time mt-1 mb-1 pl-4 pr-4"
										@click="clearContactTime"
										v-if="model.contact_time"
									>
										✕
									</vs-button>
								</div>

								<span v-if="errors.first('date')" class="text-danger text-sm">
								  {{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
						</div>
						<div v-if="model.contact_time" class="vx-row">
							<div class="vx-col pt-2 pb-2 w-full">
								<vs-checkbox
									v-model="model.contact_reminder"
									@input="updateTicket"
									class="w-full"
								>{{ $t('contactTimeReminders') }}</vs-checkbox>
							</div>
						</div>
						<div class="vx-row">
							<div class="vx-col pt-2 pb-2 w-full">
								<vs-checkbox
									v-model="model.skip_reminders"
									@input="updateTicket"
									class="w-full"
								>{{ $t('skipReminders') }}</vs-checkbox>
							</div>
						</div>
						<div  v-if="model.additional_attributes" class="vx-row">
							<div class="vx-col pt-2 pb-2 w-full">
								<vs-checkbox
									v-model="model.additional_attributes.contact_via_whatsapp"
									@input="updateTicket"
									class="w-full"
								>{{ $t('contactViaWhatsapp') }}</vs-checkbox>
							</div>
						</div>
						<div  class="vx-row">
							<div class="vx-col pt-2 pb-2 w-full">
								<vs-checkbox
									v-model="model.keep_after_emails"
									@input="updateTicket"
									class="w-full"
								>{{ $t('doNotDeleteOrderAfterEmails') }}</vs-checkbox>
							</div>
						</div>
						<div v-if="model.additional_attributes && model.additional_attributes.phone" class="vx-row">
							<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('contactPhone') }}</div>
							<div class="vx-col pt-2 pb-2 sm:w-1/3">
								{{ model.additional_attributes.phone }}
							</div>
						</div>
						<div class="vx-row mt-5">
							<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('phone') }}</div>
							<div class="vx-col pt-2 pb-2 sm:w-1/3">
								{{ phone }}
							</div>
						</div>
						<div class="vx-row mt-2 mb-3">
							<div class="vx-col w-full">
								<vs-input
									v-validate="'required'"
									v-model="model.name"
									@input="onNameInput"
									data-vv-validate-on="blur"
									:label="$t('workTheme')"
									type="text"
									name="name"
									class="w-full"
								/>
								<span v-if="errors.first('name')" class="text-danger text-sm">
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col sm:w-1/2 w-full">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<label class="vs-input--label">{{ $t('subjectArea') }}</label>
									<div class="vs-con-input"></div>
									<v-select
										v-model="model.subject"
										:clearable="false"
										:reduce="subject => subject.id"
										:options="subjects"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										@input="updateTicket(true)"
										name="work"
										label="name"
										class="single-row-select"
										:disabled="readOnly"
									/>
								</div>
								<span v-if="errors.first('work')" class="text-danger text-sm">
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="vx-col sm:w-1/2 w-full">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<label class="vs-input--label">{{ $t('workLanguage') }}</label>
									<div class="vs-con-input"></div>
									<v-select
										v-model="model.language"
										:clearable="false"
										:reduce="language => language.id"
										:options="languages"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										@input="updateTicket(true)"
										name="language"
										label="name"
										class="single-row-select"
									/>
								</div>
								<span v-if="errors.first('language')" class="text-danger text-sm">
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
						</div>
						<div class="vx-row mb-10">
							<div class="vx-col sm:w-1/2 w-full">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<label class="vs-input--label">{{ $t('qualityLevel') }}</label>
									<div class="vs-con-input"></div>
									<v-select
										:disabled="readOnly"
										v-model="model.quality_level"
										:clearable="false"
										:reduce="(level) => level.id"
										:options="levels"
										:dir="$vs.rtl ? 'rtl' : 'ltr'"
										@input="updateTicket(true)"
										name="level"
										label="name"
										class="single-row-select"
									/>
								</div>
								<span v-if="errors.first('level')" class="text-danger text-sm">
									{{ $t('fieldFilledIncorrect') }}
								</span>
							</div>
							<div class="vx-col sm:w-1/2 w-full">
								<vx-input-group>
									<div
										class="vs-component vs-con-input-label vs-input vs-input-primary"
									>
										<label class="vs-input--label">{{ $t('dueDate') }}</label>
										<div class="vs-con-input"></div>
										<vs-datepicker
											v-model="model.due_date"
											:clearable="false"
											@change="updateTicket(true)"
											format="dd.MM.yyyy"
											name="date"
										></vs-datepicker>
									</div>
									<span v-if="errors.first('date')" class="text-danger text-sm">
										{{ $t('fieldFilledIncorrect') }}
									</span>
								</vx-input-group>
							</div>
						</div>
						<div class="vx-col w-full mb-3">
							<div class="vx-col w-1/2 flex items-end">
								<vs-input
									v-model="promocodeField"
									@input="onPromocodeInput"
									:label="$t('promocode')"
									type="text"
									name="promocode"
									class="w-full mr-4"
								/>

								<div class="flex justify-center items-center">
									<vs-button
										v-if="$store.state.auth.role === 'admin' && model.promocode"
										type="flat"
										color="danger"
										@click="removePromocode"
									>
										{{ $t('delete') }}
									</vs-button>
								</div>
							</div>

							<span class="text-danger text-sm">
								<!-- {{ errors.first("name") }} -->
							</span>
						</div>

						<div class="top-border">
							<div class="top-border__container" colspan="2">
								<div class="top-border__line"></div>
							</div>
						</div>
						<div
							v-for="(item, index) in model.work_types"
							:key="index" class="works-type-list">
							<div class="vx-row works-list__container">
								<div class="vx-row vx-col works-list__row">
									<div class="vx-col w-1/2 works-list__types">
										<div
											class="vs-component vs-con-input-label vs-input vs-input-primary"
										>
											<label class="vs-input--label">{{ $t('workType') }}</label>
											<v-select
												:disabled="readOnly"
												v-model="item.work_type_id"
												v-validate="'required'"
												:clearable="false"
												:reduce="work => work.id"
												:options="works"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												@input="handleChangedWork(item.work_type_id, index)"
												name="work"
												label="name"
												class="single-row-select"
											/>
										</div>
										<span class="text-danger text-sm">
            <!--						{{ errors.first("level") }}-->
                                </span>
									</div>
									<div class="vx-col w-1/2">
										<vs-input
											:disabled="readOnly"
											v-validate="'required|numeric'"
											v-model="item.pages_number"
											@input="handleChangePages(item)"
											data-vv-validate-on="blur"
											:label="$t('pagesAmountShort')"
											type="number"
											name="pages"
											class="w-full"
										/>
										<span class="text-danger text-sm">
            <!--						{{ errors.first("name") }}-->
                                </span>
									</div>
								</div>
								<div class="vx-row vx-col works-list__row">
									<div class="vx-col w-1/2 recommended">
										<div class="vx-row">
											<div class="vx-col recommended__title">{{ $t('recommendedSumShort') }}</div>
										</div>
										<div class="vx-row recommended__price">
											<div class="vx-col">{{ Math.round(item.recommended_price) || 0 }} €</div>
										</div>
									</div>
									<div v-if="index !== 0" class="vx-col w-1/2 flex items-end works-list__delete">
										<vs-custom-button
											type="border"
											color="danger"
											@click="removeWorkType(index)"
										>{{ $t('delete') }}</vs-custom-button>
									</div>
								</div>
							</div>
						</div>
						<div class="vx-row mb-5">
							<div class="vx-col w-full">
								<div class="works-add">
									<vs-custom-button :disabled="readOnly" @click="addWorkType">{{ $t('add') }}</vs-custom-button>
								</div>
							</div>
						</div>
						<div class="vx-row mb-5">
							<div class="vx-col vx-row w-full">
								<!-- <vs-radio
									v-for="(item, index) in payTypes"
									v-model="model.pay_type"
									v-validate="'required'"
									:key="index"
									:vs-value="item.status"
									@change="updateTicket"
									vs-name="payType"
									class="vx-col"
									name="paymentMethod"
								>{{ item.label }}</vs-radio> -->
								<vs-radio
									v-for="(item, index) in filterPayTypes"
									v-model="model.pay_type"
									v-validate="'required'"
									:key="index"
									:vs-value="item.status"
									@change="updateTicket(false)"
									vs-name="payType"
									class="vx-col"
									name="paymentMethod"
								>{{ item.label }}</vs-radio>
							</div>
							<span v-if="errors.first('paymentMethod')" class="text-danger text-sm vx-col">
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-row mb-8">
							<div class="vx-col w-full">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<label class="vs-input--label">{{ $t('clientsComment') }}</label>
									<div class="vs-con-input"></div>
			<!--						<VueEditor-->
			<!--							v-model="model.description"-->
			<!--							class="card-ticket__about mb-0"-->
			<!--							v-validate="'min:3'"-->
			<!--							name="about"-->
			<!--							@input="updateTicket"-->
			<!--						/>-->
			<!--						<vs-textarea-->
			<!--							v-model="model.description"-->
			<!--							v-validate="'min:3'"-->
			<!--							@input="updateTicket"-->
			<!--							name="about"-->
			<!--							class="card-ticket__about mb-0"-->
			<!--						/>-->
									<TextEditor
										v-model="model.description"
										v-validate="'min:3'"
										@input="updateTicket(false)"
										name="about"
										class="card-ticket__about"
									/>
								</div>
								<span v-if="errors.first('about')" class="text-danger text-sm">
                                {{ $t('fieldFilledIncorrect') }}
                            </span>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-full">
								<div v-if="model.files && model.files.length > 0" class="vx-row mb-3">
									<div
										v-for="(file, index) in model.files"
										:key="index"
										class="vx-col mb-3 file-container"
									>

                                </div>
                            </div>
                            <vs-upload
                                v-model="files"
                                :key="'filesToUpload' + filesToUploadCounter"
                                :show-upload-button="false"
								accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.doc,.odt,.rtf,.pdf,.txt,.csv,.zip,.pages,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r,.ppt,.pptx"
                                :text="$t('loadFile')"
                                class="w-full"
                                @change="addPhoto"
                                @on-delete="deletePhoto"
                            />
                        </div>
                        <div class="vx-col mt-3">
                            <span
                                v-if="filesToUpload.length !== 0"
                                class="status status-ok cursor-pointer"
                                @click="uploadPhotos"
                            >{{ $t('confirmUploading') }}</span>
                        </div>
                    </div>
					<div class="top-border" v-if="model.additional_attributes && model.additional_attributes.order_details">
						<div class="top-border__container" colspan="2">
							<div class="top-border__line"></div>
						</div>
					</div>
					<div v-if="model.additional_attributes && model.additional_attributes.order_details" class="vx-row">
						<div class="vx-col w-full">
							<div>
								<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">{{ $t('details') }}</div>
								<div class="vx-col pt-2 pb-2 sm:w-1/3">
									{{ model.additional_attributes.order_details }}
								</div>
							</div>
						</div>
					</div>
					<div class="top-border" v-if="model.additional_attributes && (model.additional_attributes.client_file || model.additional_attributes.client_files) ">
						<div class="top-border__container" colspan="2">
							<div class="top-border__line"></div>
						</div>
					</div>
					<div v-if="model.additional_attributes && (model.additional_attributes.client_file || model.additional_attributes.client_files) " class="vx-row">
						<div class="vx-col pt-2 pb-2 sm:w-1/3 font-bold">
							{{ $t("client_file") }}
						</div>

						<div v-if="model.additional_attributes.client_file" class="vx-col pt-2 pb-2">
							<div class="display-block">
								<a target="_blank" :href="model.additional_attributes.client_file.file">
									{{ model.additional_attributes.client_file.file }}
								</a>
							</div>
						</div>

						<div v-if="model.additional_attributes.client_files" class="vx-col pt-2 pb-2">
							<div v-for="(client_file, index) in model.additional_attributes.client_files" :key="index" class="display-block">
								<a target="_blank" :href="client_file.file">
									{{ client_file.file }}
								</a>

								<button
									v-if="showButton"
									:disabled="client_file.isSended === 1"
									@click="sendFile(client_file)"
									class="file-container__add__btn"
								>
									+
								</button>
							</div>
						</div>

					</div>
					<CardTicketUtm v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1 && (model.utm || model.source || (model.additional_attributes && model.additional_attributes.vwo_splits))" :utm="model.utm" :source="model.source" :additional-attributes="model.additional_attributes"/>
                </div>
            </vs-tab>
            <vs-tab :label="commentsTabLabel" class="px-0">
                <VuePerfectScrollbar :settings="settings" class="pr-4">
                    <div v-if="commentsList" class="comments-list">
                        <ul v-for="(item, index) in commentsList" :key="index">
                            <li class="d-flex column list-item pb-1 mb-4">
                                <p>{{item.content}}</p>
                                <div class="d-flex mt-2 justify-between">
                                    <p>{{ item.author.firstName + ' ' + item.author.lastName }}</p>
                                    <p>{{item.created}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </VuePerfectScrollbar>
                <div class="mt-3">
					<vs-textarea
                        v-model="commentText"
                        :label="$t('comment')"
                        rows="4"
                    />
                </div>
                <div class="set-ticket-failed__controls">
                    <vs-button
                        class="mr-1"
                        color="primary"
                        :disabled="!commentText || disableCommentButton"
                        @click="sendComment"
                    >{{ $t('send') }}</vs-button>
                </div>
            </vs-tab>
            <vs-tab v-if="showViewButton" :label="$t('view')" class="px-0" isButton></vs-tab>
        </vs-tabs>
	</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";
import { VueEditor } from "vue2-editor";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import moment from "moment";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ConfirmMarginalityAction from "@/components/dialogs/ConfirmMarginalityAction.vue";

import CardTicketUtm from "@/views/Tickets/CardTicketUtm.vue";
import CardTicketIntercom from "@/views/Tickets/CardTicketIntercom.vue";
import order from "../Orders/Order.vue";
import ClientFiles from "@/views/Tickets/ClientFiles.vue";

export default {
	name: "CardTicketEdit",
	mixins: [databaseManager, notifier],
	components: {
		ClientFiles,
		vSelect,
		VueEditor,
    	VuePerfectScrollbar,
		ConfirmMarginalityAction,
		CardTicketUtm,
		CardTicketIntercom,
	},
	props: {
		model: 		{ default: null },
		subjects: 	{ default: [] },
		languages: 	{ default: [] },
		levels: 	{ default: [] },
		payTypes: 	{ default: [] },
		works: 		{ default: [] },
    isEditView: { default: false },
    isMarginalityLow: { default: false },
    inputHasChanged: { default: false },
	},
	data() {
		return {
			updateTimeout: null,
			files: [],
			filesToUpload: [],
			filesToUploadCounter: 0,
            commentText: '',
            indexTab: 0,
            disableCommentButton: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 1,
				swipeEasing: true,
			},

      		marginalityPopupState: false,
			authorFileUploadPopupState: false,

			isDeletePopupOpen: false,
			promocodeTimeout: null,
			promocodeField: this.model.promocode || '',
		}
	},
	computed: {
		authRole() {
			return this.$store.state.auth.role;
		},
		showButton() {
			if (this.authRole === "admin" || this.authRole === "manager")
				return true;
			return false;
		},
		order() {
			return order
		},
        readOnly() {
            if(this.model.status === 'new'
				|| this.model.status === 'client_not_answer'
				|| this.model.status === 'offer_sent'
				|| this.model.status === 'work_long_term'
				|| this.model.status === 'processing') return false
            return true
        },
        showViewButton() {
            if(this.model.status === 'new'
                || this.model.status === 'client_not_answer'
                || this.model.status === 'offer_sent'
				|| this.model.status === 'work_long_term'
				|| this.model.status === 'processing') return false
            return true
        },
		hasClientFiles() {
			return this.model.files && Array.isArray(this.model.files) && this.model.files.length > 0;
		},
        canShowCommentsTab() {
            const role = this.$store.state.auth.role
            return role === 'manager' || role === 'admin'
        },
		cleanDescription() {
			return this.model.description
				? this.model.description.replace(/<[^>]*>/g, '').trim()
				: '';
		},
        commentsTabLabel() {
            const commentsTitle = this.$t('comments')
            if (this.model && this.model.comments) {
                const count = this.model.comments
                if (count.length) {
                    return `${commentsTitle} (${count.length})`
                }
                return commentsTitle
            }
            return commentsTitle
        },
        commentsList() {
            return this.model ? this.model.comments : null
        },
		phone() {
            const model = this.model
            if (model && model.client && model.client.phone) return this.model.client.phone
            return '---'
		},
		filterPayTypes() {
			return this.payTypes.filter(el => el.status === 2)
		},
		minDate() {
			return new Date();
		},
		websiteName() {
			return this.model.website || "---";
		},
		clientId() {
			if(!this.model.client) return "---";
			return this.model.client.id;
		},
		clientName() {
			if(!this.model.client) return "---";
			return this.model.client.full_name !== ""
				? this.model.client.full_name : "---";
		},
		pathToClient() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return "client";
			} else if(role === "manager") {
				return "clientM";
			}
		},
		updatedTicketId() {
			if (this.$route.params.id)
				return this.$route.params.id
		},

	},

    watch: {
        indexTab(newVal) {
            if (newVal) {
                this.commentText = ''
            }
        }
    },
	async mounted() {
		this.$root.$on('fileAddedToOrder', this.updateClientFilesFromChat);
	},
	beforeDestroy() {
		this.$root.$off('fileAddedToOrder', this.updateClientFilesFromChat);
	},
	methods: {

		async sendFile(file) {
			try {
				const response = await this.$http.post(
					`${this.$store.state.auth.role}/order/add-file-by-base-path`,
					{
						order_id: this.model.id,
						file_base_path: file.base_patch
					}
				);
				this.notifySuccess(this.$t('addedSuccessfully'));
				this.$emit('updateModel')

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async createTask() {
          try {
            await this.dbCreateMarginalityTask(this.model.id)

            this.setButtonAction()
            this.marginalityPopupState = false
          } catch (e) {
            console.error(e);
          }
        },

        checkMarginalityState() {
            if (this.isMarginalityLow && this.inputHasChanged) {
              this.marginalityPopupState = true
            } else {
              this.setButtonAction()
            }
        },
		async viewOrder() {
			const id = this.updatedTicketId;
			return await this.dbViewOrder(id);
		},
		async updateModelAfterDeleteFiles() {
			this.model = await this.viewOrder();
			await this.updateStages()
		},
		async updateModelAfterDeleteClientFiles() {
			this.model = await this.viewOrder();
			await this.updateClientFiles();
		},
		async updateClientFiles() {
			try {
				this.files = this.model.files;
			} catch (e) {
				console.error(e);
			}
		},

		setButtonAction() {
            this.$emit('update:isEditView', false)
        },
        setActiveTab(data) {
            this.indexTab = data
        },
        async sendComment() {
            this.disableCommentButton = true
            try {
                await this.dbSendComment(this.model.id, this.commentText);
                this.disableCommentButton = false
                this.notifySuccess(this.$t('addedSuccessfully'));
                this.commentText = ''
                this.$emit('updateModel')
            } catch (e) {
                this.notifyError(e.message);
                this.disableCommentButton = false
            }
        },
		openImagePopup(e, file) {
			this.$emit('openImagePopup', e, file)
		},
		async validateOrder() {
			return await this.$validator.validateAll();
		},
		getFileName(file) {
			const path = file.url.split("/");
			let filePath = path[path.length - 1]
			// if (filePath.length > 40) return filePath.substr(0, 40) + '...'
			return filePath
		},
		async updateTicket(recalcPrices = false) {
			await this.updateTicketAsync();
			  setTimeout(() => {
				this.$emit('recalcPrices', recalcPrices)
			  }, 1000);
		},
		onNameInput() {
			if (this.nameTimeout) {
				clearTimeout(this.nameTimeout)
			}

			this.nameTimeout = setTimeout(() => {
				this.updateTicket(true)
				this.nameTimeout = null
			}, 1500)
		},
		onPromocodeInput() {
			if (this.promocodeTimeout) {
				clearTimeout(this.promocodeTimeout);
			}

			this.promocodeTimeout = setTimeout(() => {

				if (this.$store.state.auth.role !== 'admin' && this.promocodeField === '') {
					this.promocodeField = this.model.promocode;
					this.notifyError(this.$t('onlyAdminCanRemovePromocode'));
					this.promocodeTimeout = null;
					return;
				}

				this.model.promocode = this.promocodeField;
				this.updateTicket(true);
				this.promocodeTimeout = null;
			}, 1500);
		},

		removePromocode() {
			this.model.promocode = '';
			this.promocodeField = '';
			this.updateTicket(true);
		},
		clearContactTime() {
			this.model.contact_time = null;
			this.updateTicket(true);
		},
		updateWorkTypes(workTypes) {
			for(let work of workTypes) {
				const match = this.model.work_types.find(item => item.work_type_id === work.work_type_id);

				if(match === undefined) return;

				work.recommended_price = match.recommended_price;
			}

			this.model.work_types = workTypes;
		},
		async updateTicketAsync(isImmediate = false){
			if(await this.$validator.validateAll() !== true) return;

			if(!isImmediate) {
				if(this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				}

				this.updateTimeout = setTimeout(() => {
					this.updateTicketAsync(true);
					this.updateTimeout = null;
				}, 500);

				return;
			}

			try {
				if(await this.$validator.validateAll() !== true) return;

        		const date = this.model.due_date ? moment(this.model.due_date).format("YYYY-MM-DD") : null
				const contactTime = this.model.contact_time ? moment(this.model.contact_time).format("YYYY-MM-DD") : null

				const workTypes = this.model.work_types;

				const data = {
					name: this.model.name,
					subject: this.model.subject,
					work_types: workTypes.map(item => ({
						work_type: item.work_type_id,
						pages_number: item.pages_number,
					})),
					quality_level: this.model.quality_level,
					pages_number: this.model.pages_number,
					language: this.model.language,
					pay_type: this.model.pay_type,
					due_date: date,
					description: this.model.description,
					skip_reminders: this.model.skip_reminders ? 1 : 0,
					contact_reminder: this.model.contact_reminder ? 1 : 0,
					contact_via_whatsapp: this.model.additional_attributes && this.model.additional_attributes.contact_via_whatsapp ? 1 : 0,
					files: this.model.files.map(item => item.url),
					contact_time: contactTime,
					promocode: this.model.promocode,
					parent_id: this.model.parent_id,
					keep_after_emails: this.model.keep_after_emails ? 1 : 0,
					generator_manager_id: this.model.generator_manager_id,
				};

				const updated = await this.dbUpdateOrder(this.model.id, data);
				await this.$emit("updateTicket", updated);

				this.updateWorkTypes(workTypes);

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async handleChangedWork(type, index) {
			const matches = this.model.work_types.filter(work => work.work_type_id === type);

			if(matches.length > 1) {
				this.model.work_types.splice(index, 1);
			}

			await this.updateTicket(true);
			setTimeout(() => this.$emit("updatedWorkType", type), 200);
		},
		async handleChangePages(stage) {
			stage.pages_number = (+stage.pages_number).toString();

			if(stage.work_type_id !== 0) {
				await this.updateTicket(true);
			}
		},
		addPhoto(path, files) {
			this.filesToUpload.push(files[files.length - 1]);
		},
		deletePhoto(file) {
			const index = this.filesToUpload.findIndex(item => item === file);
			if(index !== -1) {
				this.filesToUpload.splice(index, 1);
			}
		},
		async uploadPhotos() {
			try {
				const urls = await this.dbUploadMany(this.filesToUpload);
				const successfulUploads = urls.length;
				const totalFiles = this.filesToUpload.length;

				if (successfulUploads < totalFiles) {
					this.notifyError(
						this.$t('uploadWarning', { success: successfulUploads, total: totalFiles })
					);
				}

				urls.forEach(item => this.model.files.push(item));
				this.filesToUpload = [];
				this.filesToUploadCounter++;

				await this.updateTicket();
			} catch (error) {
				this.notifyError(this.$t('notAllowedFileType'));
			}
		},
		confirmFileDeletion(file) {
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: this.$t('confirmDeletion'),
				text: this.$t('doYouWantToDeleteFile'),
				accept: () => this.deleteUploadedPhoto(file),
				acceptText: this.$t('confirm'),
				cancelText: this.$t('cancel')
			});
		},
		async deleteUploadedPhoto(file) {
			try {
				const start = file.url.indexOf('/upload');
				const filePath = file.url.substr(start);

				await this.dbDeleteOne(this.model.id, filePath);
				await this.updateTicket();

				this.notifySuccess(this.$t('fileDeletedSuccessfully'));
			} catch {
				this.notifyError(this.$t('fileDeletionError'));
			}
		},
		async addWorkType() {
			this.model.work_types.push({
				work_type_id: 0,
				pages_number: 0,
				recommended_price: 0
			});
		},
		async removeWorkType(index) {
			this.model.work_types.splice(index, 1);
			await this.updateTicket();

			let type = null;

			if(this.model.work_types.length !== 0) {
				type = this.model.work_types[0].work_type_id;
			}

			setTimeout(() => this.$emit("updatedWorkType", type), 200);
		},
	},
}
</script>

<style lang="scss">

.card-ticket {
	.edit-ticket-tabs {
		.files-from-client {
			box-sizing: border-box;
			overflow: hidden;
			overflow-wrap: break-word;
			word-break: break-word;
			white-space: normal;
		}
	}

	.file-container {
		@media screen and (max-width: 1460px) and (min-width: 992px) {
			width: 70%;
		}
		max-width: 75%;
	}
	.con-vs-tabs .con-slot-tabs {
        overflow: visible !important;
    }
	.stages-files {
		box-shadow: none;
	}
    .file-container {
        @media screen and (max-width: 600px) {
            width: 100%;
        }
        .fileName {
            @media screen and (max-width: 600px) {
                width: 100%;
            }
            padding-right: 0;
            &__text {
                max-width: 300px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                @media screen and (max-width: 600px) {
                    max-width: 100%;
                }
            }
            &__close {
                background: none !important;
            }
        }
		&__add__btn {
			height: 30px;
			padding: 0 10px;
			margin-left: 0.5rem;
			border: none;
			border-radius: 40%;
			background: #3ac47d;
			cursor: pointer;
			transition: all ease 0.3s;
			color: white;

			&:hover {
				background: #258352;
			}

			&:disabled {
				background: #3ac47d6c;
				cursor: default;
			}
		}
    }

	&__about {
		display: flex;
		flex-direction: column;
		min-height: 280px;

		textarea {
			flex: 1 0 auto;
			//height: 100%;
		}

		.vs-textarea:focus {
			resize: none !important;
		}
	}
	.works-list {
		padding-top: 25px;
		margin-top: 25px;
	}
	.works-list {
		border-top: 1px solid #e4e4e4;
		padding-top: 25px;
		margin-top: 25px;

		&__row {
			flex: 100px 1 1;
		}

		.vs-button {
			width: 100%;
			padding-left: 0 !important;
			padding-right: 0 !important;
		}

		.recommended {
			padding-top: 0.1rem;
			&__title {
				font-size: .85rem;
			}

			&__price {
				padding-top: .80rem;
			}
		}

		@media
		screen and (max-width: 1460px) and (min-width: 992px),
		screen and (max-width: 540px){

			&__container {
				flex-direction: row;
			}

			&__row {
				&:first-child {
					flex: 60%;
					flex-direction: column;
				}

				&:last-child {
					flex: 40%;
					flex-direction: column-reverse;
				}

				.vx-col {
					width: 100% !important;
					flex-basis: 1px;
					flex-grow: 1;
					flex-shrink: 1;
				}
			}
		}

		&__types, &__delete {
			margin-bottom: 10px;
		}
	}

	.works-add {
		border-bottom: 1px solid #e4e4e4;
		padding-bottom: 25px;
		margin-top: 25px;
	}

	.top-border {
		column-span: 2;

		&__container {
			padding-top: 10px;
			padding-bottom: 15px;
		}

		&__line {
			border-top: 1px solid #e4e4e4;
		}
	}
  .ps {
      max-height: 450px;
  }

  .comments-list {
      overflow-y: auto;
      scrollbar-width: thin;

      .list-item {
          border-bottom: 1px solid #cfcfcf;
      }
  }

}

.intercom-card {
	align-items: center;
	.vs-button {
		padding: 0 0.8rem !important;
		font-size: .9em !important;
		height: 30px;
	}
	.intercom-id {
		line-height: 38px;
		font-size: 0.8em;
		margin-top: -25px;
	}
}
.display-block {
	display: block;
}
</style>
